import React from 'react';
import { Box, Typography, Button, Container } from '@mui/material';
import { Link } from 'react-router-dom';

const NotFound = () => {
  return (
    <Container maxWidth="sm" sx={{ textAlign: 'center', mt: 10 }}>
      {/* Error message */}
      <Typography variant="h1" sx={{ fontWeight: 'bold', fontSize: '96px', color: '#ff5252' }}>
        404
      </Typography>
      <Typography variant="h5" sx={{ mb: 3 }}>
        Oops! The page you're looking for doesn't exist.
      </Typography>

      {/* Optional image or icon */}
      <Box
        component="img"
        src="/assets/404_image.png" // Replace with the actual image path in your assets folder
        alt="Page Not Found"
        sx={{ width: '100%', maxWidth: '300px', mb: 3 }}
      />

      {/* Back to home button */}
      <Button variant="contained" color="primary" component={Link} to="/" sx={{ mt: 3 }}>
        Back to Home
      </Button>
    </Container>
  );
};

export default NotFound;
